import SentryPlugin from '@ciclicbr/sentry-plugin'
import info from '../../package.json'

export default [SentryPlugin, {
  dsn: 'https://61f0f3979fe64fb99d6035c92f27c487@o96223.ingest.sentry.io/5535238',
  project: 'devices-front',
  version: info.version,
  environment: process.env.VUE_APP_ENV || process.env.NODE_ENV
}]
